import actions from './actions';
import reducer from './reducers';

export { actions };

export default reducer;



// WEBPACK FOOTER //
// ./src/venue/index.js